











import { defineComponent, toRef } from "@vue/composition-api";
import useUploadingProgress from "../hooks/useUploadingProgress";

export default defineComponent({
  name: "LoadingListItem",
  props: {
    progress: { type: Number, default: 0 },
  },
  setup(props) {
    const { loading, loaded } = useUploadingProgress(toRef(props, "progress"));
    return { loading, loaded };
  },
});
